// Arabic strings for the field screens owned by fieldA: Scan home, Asset quick view, Sync status, offline queue messages,
// Location contents sheet, Guest loaners, scanned-tag landing page. Keyed by the English source text; {name} placeholders stay as-is.
export default {
  " (browser storage in use: {size})": " (مساحة تخزين المتصفح المستخدمة: {size})",
  " (Overdue {time})": " (متأخر {time})",
  " A Repair Record was raised for the damaged item.": " تم إنشاء سجل إصلاح للصنف التالف.",
  " A replacement charge of {currency} {amount} was recorded.": " تم تسجيل رسوم استبدال بقيمة {currency} {amount}.",
  " Ask a storekeeper or the onboarding team to bind it.": " اطلب من أمين المخزن أو فريق التهيئة ربطه.",
  " for {property}": " لـ {property}",
  " · from offline data": " · من البيانات المحفوظة دون اتصال",
  "\"{code}\" is not in the data prepared for offline use. Check the code, or try again when you are back online.": "\"{code}\" غير موجود في البيانات المُعدّة للاستخدام دون اتصال. تحقق من الرمز أو حاول مرة أخرى عند عودة الاتصال.",
  "(optional)": "(اختياري)",
  "({n} available)": "({n} متاح)",
  ", inactive": "، غير نشط",
  "100% in good condition": "100% بحالة جيدة",
  "A Repair Record (or a replacement charge for an unregistered item) will be raised automatically and the item withdrawn from the fleet.": "سيُنشأ سجل إصلاح (أو رسوم استبدال لصنف غير مسجل) تلقائيًا وسيُسحب الصنف من الأسطول.",
  "Across {n} guest room": "في {n} غرفة نزلاء",
  "Across {n} guest rooms": "في {n} غرف نزلاء",
  "Actions taken offline wait here and sync in the order they were taken. Prepare for offline before a shift so rooms, count sheets and assets are on this device.": "تنتظر الإجراءات المتخذة دون اتصال هنا وتُزامن بالترتيب الذي اتُّخذت به. جهّز للعمل دون اتصال قبل الوردية لتكون الغرف وأوراق العد والأصول على هذا الجهاز.",
  "Active": "نشط",
  "Active & Recent Guest Loans": "إعارات النزلاء النشطة والأخيرة",
  "Active On-Loan": "المُعار حاليًا",
  "All Statuses": "كل الحالات",
  "Asset": "أصل",
  "Asset quick view": "العرض السريع للأصل",
  "Asset quick view saved": "تم حفظ العرض السريع للأصول",
  "Asset tag or short code": "وسم الأصل أو الرمز القصير",
  "Audit": "جرد",
  "Audit checklists": "قوائم تحقق الجرد",
  "Audit scan": "مسح الجرد",
  "Automated reminder notification sent to {room} supervisors for {item} ({n} recipient).": "تم إرسال تذكير تلقائي إلى مشرفي {room} بشأن {item} ({n} مستلم).",
  "Automated reminder notification sent to {room} supervisors for {item} ({n} recipients).": "تم إرسال تذكير تلقائي إلى مشرفي {room} بشأن {item} ({n} مستلمين).",
  "Bind this tag to an asset": "اربط هذا الوسم بأصل",
  "Blind count": "عد أعمى",
  "Camera preview": "معاينة الكاميرا",
  "Camera unavailable": "الكاميرا غير متاحة",
  "Camera unavailable ({msg}). Type the code printed under the tag instead.": "الكاميرا غير متاحة ({msg}). اكتب الرمز المطبوع أسفل الوسم بدلاً من ذلك.",
  "Category": "الفئة",
  "Choose a location": "اختر موقعًا",
  "Choose a location to see what should be in it.": "اختر موقعًا لترى ما يجب أن يحتويه.",
  "Choose a room, floor, wing or building…": "اختر غرفة أو طابقًا أو جناحًا أو مبنى…",
  "Choose where the asset is going.": "اختر وجهة الأصل.",
  "Completed": "مكتمل",
  "Condition": "الحالة",
  "Condition now": "الحالة الآن",
  "Condition on return": "الحالة عند الإعادة",
  "Condition Rating *": "تقييم الحالة *",
  "Condition: {condition}": "الحالة: {condition}",
  "Confirm Issue & Dispatch": "تأكيد الإصدار والإرسال",
  "Confirm Return": "تأكيد الإعادة",
  "Confirm return of": "تأكيد إعادة",
  "Conflict": "تعارض",
  "Conflicts": "التعارضات",
  "Connection": "الاتصال",
  "Could not read the selected photo": "تعذرت قراءة الصورة المحددة",
  "Count sheets": "أوراق العد",
  "Counted": "المعدود",
  "Custodian": "أمين العهدة",
  "Custody return": "إعادة العهدة",
  "Damage report": "بلاغ تلف",
  "Damage reported ({ref}) with a photo.": "تم الإبلاغ عن التلف ({ref}) مع صورة.",
  "Damage reported for {tag} ({ref}).": "تم الإبلاغ عن تلف {tag} ({ref}).",
  "Damage reported for {tag}.": "تم الإبلاغ عن تلف {tag}.",
  "Damage reported with a photo.": "تم الإبلاغ عن التلف مع صورة.",
  "Damaged": "تالف",
  "Describe any damage": "صف أي تلف",
  "Describe the damage (at least 5 characters).": "صف التلف (5 أحرف على الأقل).",
  "Discard": "تجاهل",
  "Dismiss": "إخفاء",
  "Disposed": "مستبعد",
  "Download progress": "تقدم التنزيل",
  "Downloading": "جارٍ التنزيل",
  "Downloading the property and its locations": "جارٍ تنزيل العقار ومواقعه",
  "Downloading…": "جارٍ التنزيل…",
  "Downloads your open and assigned audits with the expected contents of up to 300 rooms, the count sheets of your property's stock points, first-walk rooms and the quick-view details of every asset, so a full shift works without a connection.": "ينزّل عمليات الجرد المفتوحة والمسندة إليك مع المحتويات المتوقعة لما يصل إلى 300 غرفة، وأوراق عد نقاط المخزون في عقارك، وغرف الجولة الأولى، وتفاصيل العرض السريع لكل أصل، لتعمل وردية كاملة دون اتصال.",
  "e.g. John Doe": "مثال: محمد أحمد",
  "e.g. RM-201 or AOS7K9": "مثال: RM-201 أو AOS7K9",
  "e.g. Room 402": "مثال: الغرفة 402",
  "Engineering": "الهندسة",
  "Excellent": "ممتاز",
  "Expected Return": "الإعادة المتوقعة",
  "Expected Return Window *": "فترة الإعادة المتوقعة *",
  "Export XLSX": "تصدير XLSX",
  "Exporting…": "جارٍ التصدير…",
  "Fair": "مقبول",
  "Field app": "التطبيق الميداني",
  "Filter by status": "تصفية حسب الحالة",
  "Find an asset": "ابحث عن أصل",
  "First-walk exception": "استثناء الجولة الأولى",
  "First-walk rooms": "غرف الجولة الأولى",
  "Found in another room": "وُجد في غرفة أخرى",
  "from": "من",
  "Front Office": "المكتب الأمامي",
  "Give a reason for the move (at least 3 characters).": "اذكر سبب النقل (3 أحرف على الأقل).",
  "Good": "جيد",
  "Guest loaner issued successfully! {item} ({tag}) is out with {room}; return reminder scheduled for {when}.": "تم إصدار صنف الإعارة للنزيل بنجاح! {item} ({tag}) لدى {room}؛ تمت جدولة تذكير الإعادة في {when}.",
  "Guest Loaners & Overdue Tracker": "إعارات النزلاء ومتابعة المتأخرات",
  "Guest Name": "اسم النزيل",
  "Guest Room Number *": "رقم غرفة النزيل *",
  "Guest room number is required": "رقم غرفة النزيل مطلوب",
  "Guest Services": "خدمات النزلاء",
  "has been printed but is not attached to an asset, location or Stock Point yet.": "تمت طباعته ولكنه غير مرتبط بأصل أو موقع أو نقطة مخزون بعد.",
  "Housekeeping": "التدبير المنزلي",
  "How urgent?": "ما مدى الاستعجال؟",
  "In repair": "قيد الإصلاح",
  "In service": "في الخدمة",
  "In store": "في المخزن",
  "In transit": "قيد النقل",
  "Inactive": "غير نشط",
  "Issue Guest Loaner Item": "إصدار صنف إعارة للنزيل",
  "Issue Loaner Item": "إصدار صنف إعارة",
  "Issued": "مُصدَر",
  "Item": "الصنف",
  "Kit:": "المجموعة:",
  "Last audit": "آخر جرد",
  "Last sync: {when}": "آخر مزامنة: {when}",
  "Last try: {error}": "المحاولة الأخيرة: {error}",
  "Loading contents…": "جارٍ تحميل المحتويات…",
  "Loading guest loans...": "جارٍ تحميل إعارات النزلاء...",
  "Loading property…": "جارٍ تحميل العقار…",
  "Loan Fleet Availability": "توفر أسطول الإعارة",
  "Loaned At": "وقت الإعارة",
  "Loaner Item": "صنف الإعارة",
  "Location": "الموقع",
  "Location Contents Sheet": "ورقة محتويات الموقع",
  "Locations saved": "تم حفظ المواقع",
  "Look up": "بحث",
  "Looking up the tag…": "جارٍ البحث عن الوسم…",
  "Low (minor / scheduled)": "منخفض (بسيط / مجدول)",
  "More than one asset matches": "يطابق أكثر من أصل",
  "Move": "نقل",
  "Move of {tag} to {place} recorded and sent for approval.": "تم تسجيل نقل {tag} إلى {place} وإرساله للموافقة.",
  "Move of {tag} to {place} recorded.": "تم تسجيل نقل {tag} إلى {place}.",
  "Needs your attention": "بحاجة إلى انتباهك",
  "Never": "أبدًا",
  "New": "جديد",
  "Next": "التالي",
  "No conflicts. If the server refuses a synced action (for example the item was moved, the audit was completed or the count was already submitted), it appears here for you to retry, discard or open.": "لا توجد تعارضات. إذا رفض الخادم إجراءً تمت مزامنته (مثلاً نُقل الصنف أو اكتمل الجرد أو أُرسل العد مسبقًا)، فسيظهر هنا لتعيد المحاولة أو تتجاهله أو تفتحه.",
  "No guest loans found.": "لم يتم العثور على إعارات للنزلاء.",
  "No loaner items registered": "لا توجد أصناف إعارة مسجلة",
  "No locations are available offline. Prepare for offline on the Sync status page first.": "لا توجد مواقع متاحة دون اتصال. جهّز للعمل دون اتصال من صفحة حالة المزامنة أولاً.",
  "No pooled stock is held here.": "لا يوجد مخزون مجمّع هنا.",
  "No returns yet today": "لا توجد إعادات اليوم بعد",
  "No tagged assets here. Stamp a kit to create the room's expected contents.": "لا توجد أصول موسومة هنا. اختم مجموعة لإنشاء المحتويات المتوقعة للغرفة.",
  "No {item} is currently available": "لا يوجد {item} متاح حاليًا",
  "Normal": "عادي",
  "Not accepted": "غير مقبول",
  "Not assigned": "غير مُسند",
  "Not audited yet": "لم يُجرد بعد",
  "Notes": "ملاحظات",
  "Nothing has been prepared on this device yet.": "لم يتم تجهيز أي شيء على هذا الجهاز بعد.",
  "Nothing is waiting. Scans, counts, bindings and moves you make offline are kept here until they reach the server.": "لا شيء بالانتظار. تُحفظ عمليات المسح والعد والربط والنقل التي تجريها دون اتصال هنا حتى تصل إلى الخادم.",
  "Nothing overdue": "لا يوجد متأخر",
  "Nudge guests from the list below": "ذكّر النزلاء من القائمة أدناه",
  "Nudge Room": "تذكير الغرفة",
  "Offline": "غير متصل",
  "Offline - syncs automatically when back online": "غير متصل - تتم المزامنة تلقائيًا عند عودة الاتصال",
  "Offline: the damage report for {tag} is saved on this device and sent when you are back online (photos need a connection, so it is sent without one).": "دون اتصال: تم حفظ بلاغ تلف {tag} على هذا الجهاز وسيُرسل عند عودة الاتصال (الصور تحتاج إلى اتصال، لذا سيُرسل بدونها).",
  "Offline: the damage report for {tag} is saved on this device and sent when you are back online.": "دون اتصال: تم حفظ بلاغ تلف {tag} على هذا الجهاز وسيُرسل عند عودة الاتصال.",
  "Offline: the move of {tag} is saved on this device and recorded when you are back online.": "دون اتصال: تم حفظ نقل {tag} على هذا الجهاز وسيُسجَّل عند عودة الاتصال.",
  "Offline: the new condition of {tag} is saved on this device and recorded when you are back online.": "دون اتصال: تم حفظ الحالة الجديدة لـ {tag} على هذا الجهاز وستُسجَّل عند عودة الاتصال.",
  "Offline: the return of {tag} is saved on this device and recorded when you are back online.": "دون اتصال: تم حفظ إعادة {tag} على هذا الجهاز وستُسجَّل عند عودة الاتصال.",
  "On hand": "المتوفر",
  "Online": "متصل",
  "Open": "فتح",
  "Open record": "فتح السجل",
  "Open the first scan walk": "افتح جولة المسح الأولى",
  "Open the full record": "افتح السجل الكامل",
  "Open {asset}": "فتح {asset}",
  "Opening the asset, location or Stock Point this label belongs to.": "جارٍ فتح الأصل أو الموقع أو نقطة المخزون التي ينتمي إليها هذا الملصق.",
  "Or type the code (room code, asset tag or the short code under the barcode)": "أو اكتب الرمز (رمز الغرفة أو وسم الأصل أو الرمز القصير أسفل الباركود)",
  "Out of service": "خارج الخدمة",
  "Overdue": "متأخر",
  "Overdue Past Deadline": "متأخر عن الموعد",
  "Par": "المستوى المعياري",
  "Pending": "قيد الانتظار",
  "Photo": "صورة",
  "Photos must be JPEG, PNG or WebP images.": "يجب أن تكون الصور بصيغة JPEG أو PNG أو WebP.",
  "Photos need a connection; the report is saved without one and sent when you are back online.": "الصور تحتاج إلى اتصال؛ يُحفظ البلاغ بدونها ويُرسل عند عودة الاتصال.",
  "Point the camera at a room's door tag to start its audit, or at an asset's tag to see its status and act on it.": "وجّه الكاميرا إلى وسم باب الغرفة لبدء جردها، أو إلى وسم الأصل لعرض حالته واتخاذ إجراء.",
  "Pooled stock ({n})": "المخزون المجمّع ({n})",
  "Poor (damaged)": "سيئ (تالف)",
  "Prepare for offline": "التجهيز للعمل دون اتصال",
  "Prepared {when}": "تم التجهيز {when}",
  "Preparing needs a connection.": "يتطلب التجهيز اتصالاً.",
  "Previous": "السابق",
  "Print": "طباعة",
  "Printed {when}": "طُبع {when}",
  "Property": "العقار",
  "Quick Return": "إعادة سريعة",
  "Reason": "السبب",
  "Reason for the move": "سبب النقل",
  "Receiving department": "القسم المستلم",
  "Recondition": "إعادة التأهيل",
  "Record move": "تسجيل النقل",
  "Record return": "تسجيل الإعادة",
  "Refresh offline data": "تحديث بيانات العمل دون اتصال",
  "Report damage": "الإبلاغ عن تلف",
  "Report issue": "الإبلاغ عن مشكلة",
  "Reports": "التقارير",
  "Retired": "متقاعد",
  "Retry": "إعادة المحاولة",
  "Return": "إعادة",
  "Return from custody": "الإعادة من العهدة",
  "Returned": "مُعاد",
  "Returned damaged": "أُعيد تالفًا",
  "Returned Today": "المُعاد اليوم",
  "Room #": "رقم الغرفة",
  "Room sign-off": "اعتماد الغرفة",
  "Save condition": "حفظ الحالة",
  "Saved for offline use - details may have changed since.": "محفوظ للاستخدام دون اتصال - ربما تغيرت التفاصيل منذ ذلك الحين.",
  "Scan a room or asset tag. A room offers its audit; an asset opens its quick view. Works offline once the shift is prepared.": "امسح وسم غرفة أو أصل. الغرفة تعرض جردها، والأصل يفتح عرضه السريع. يعمل دون اتصال بعد تجهيز الوردية.",
  "Scan a tag or type the code printed under it.": "امسح وسمًا أو اكتب الرمز المطبوع أسفله.",
  "Scan an asset tag from Scan, or type its code below.": "امسح وسم أصل من شاشة المسح، أو اكتب رمزه أدناه.",
  "Scanned Tag": "الوسم الممسوح",
  "Search loans": "البحث في الإعارات",
  "Search room, guest, item...": "ابحث عن غرفة أو نزيل أو صنف...",
  "Select an expected return window": "اختر فترة الإعادة المتوقعة",
  "Select Available Equipment *": "اختر المعدات المتاحة *",
  "Select item...": "اختر صنفًا...",
  "Select the equipment to issue": "اختر المعدات المراد إصدارها",
  "Send damage report": "إرسال بلاغ التلف",
  "Serial": "الرقم التسلسلي",
  "Starting": "جارٍ البدء",
  "Status": "الحالة",
  "Status, condition and last audit, with the actions you can take here. Actions work offline and sync later.": "الحالة والوضع وآخر جرد، مع الإجراءات التي يمكنك اتخاذها هنا. تعمل الإجراءات دون اتصال وتُزامن لاحقًا.",
  "Stop": "إيقاف",
  "Stored on this device: {size}": "المخزّن على هذا الجهاز: {size}",
  "Storekeeper": "أمين المخزن",
  "Sync finished: {parts}.": "اكتملت المزامنة: {parts}.",
  "Sync now": "زامن الآن",
  "Sync paused; it resumes automatically": "المزامنة متوقفة مؤقتًا؛ ستُستأنف تلقائيًا",
  "Sync status": "حالة المزامنة",
  "Syncing…": "جارٍ المزامنة…",
  "Tag": "الوسم",
  "Tag binding": "ربط الوسم",
  "Tag not bound yet": "الوسم غير مربوط بعد",
  "Tag {code} belongs to a stock point. Open Blind Counts to count it.": "الوسم {code} يتبع نقطة مخزون. افتح العد الأعمى لعدّه.",
  "Tag {code} has been retired. Replace the label with a new tag.": "تم إيقاف الوسم {code}. استبدل الملصق بوسم جديد.",
  "Tag {code} is no longer in use and cannot be bound again. Replace the label with a new tag.": "الوسم {code} لم يعد مستخدمًا ولا يمكن ربطه مجددًا. استبدل الملصق بوسم جديد.",
  "Tag {code} is not attached to an asset yet. Bind it during the first scan walk.": "الوسم {code} غير مرتبط بأصل بعد. اربطه أثناء جولة المسح الأولى.",
  "Tag: {tag}": "الوسم: {tag}",
  "Tagged assets ({n})": "الأصول الموسومة ({n})",
  "taken {when}": "اتُّخذ {when}",
  "That tag is not attached to an asset.": "هذا الوسم غير مرتبط بأصل.",
  "The action was not accepted": "لم يُقبل الإجراء",
  "the asset it was on": "الأصل الذي كان عليه",
  "The download needs a connection. Try again when you are online.": "يتطلب التنزيل اتصالاً. حاول مرة أخرى عند الاتصال.",
  "The label may belong to another property, or the code was read incorrectly. Try typing the short code printed under the barcode.": "قد يتبع الملصق عقارًا آخر، أو قُرئ الرمز بشكل خاطئ. جرّب كتابة الرمز القصير المطبوع أسفل الباركود.",
  "the new location": "الموقع الجديد",
  "The record changed while you were offline": "تغيّر السجل أثناء عدم اتصالك",
  "The tag could not be looked up": "تعذر البحث عن الوسم",
  "This asset was not found, or it belongs to a property you cannot see.": "لم يتم العثور على هذا الأصل، أو أنه يتبع عقارًا لا يمكنك الاطلاع عليه.",
  "This browser cannot read tags with the camera. Type the code printed under the tag, or use a handheld scanner into the field below.": "لا يستطيع هذا المتصفح قراءة الوسوم بالكاميرا. اكتب الرمز المطبوع أسفل الوسم، أو استخدم ماسحًا يدويًا في الحقل أدناه.",
  "This property has no locations yet": "لا توجد مواقع لهذا العقار بعد",
  "This tag has been retired": "تم إيقاف هذا الوسم",
  "To location": "إلى الموقع",
  "Track loaner items issued to guest rooms and follow up on overdue returns.": "تتبع أصناف الإعارة الصادرة لغرف النزلاء وتابع الإعادات المتأخرة.",
  "Urgent (guest-facing / safety)": "عاجل (يخص النزلاء / السلامة)",
  "Waiting": "بالانتظار",
  "Waiting to sync": "بانتظار المزامنة",
  "We could not find this tag": "لم نتمكن من العثور على هذا الوسم",
  "What is in a room right now: tagged assets one by one and pooled stock against par. Pick a floor or wing to print one sheet per room.": "ما يوجد في الغرفة الآن: الأصول الموسومة واحدًا تلو الآخر والمخزون المجمّع مقابل المستوى المعياري. اختر طابقًا أو جناحًا لطباعة ورقة لكل غرفة.",
  "What is wrong?": "ما المشكلة؟",
  "Will retry": "ستتم إعادة المحاولة",
  "Written off": "مشطوب",
  "You are offline and nothing has been prepared for offline use yet. Open Sync status and choose Prepare for offline before your next shift.": "أنت غير متصل ولم يتم تجهيز أي شيء للاستخدام دون اتصال بعد. افتح حالة المزامنة واختر التجهيز للعمل دون اتصال قبل ورديتك التالية.",
  "You are offline. Actions stay on this device and sync automatically when the connection returns.": "أنت غير متصل. تبقى الإجراءات على هذا الجهاز وتُزامن تلقائيًا عند عودة الاتصال.",
  "Your role can view this asset but has no actions on it.": "يمكن لدورك عرض هذا الأصل ولكن دون أي إجراءات عليه.",
  "Your role has no field actions for a room. Scan an asset tag to see the asset.": "ليس لدورك إجراءات ميدانية على الغرفة. امسح وسم أصل لعرضه.",
  "Your session has expired. Sign in again to sync; nothing on this device is lost.": "انتهت جلستك. سجّل الدخول مرة أخرى للمزامنة؛ لن يُفقد أي شيء على هذا الجهاز.",
  "{checklists} room checklists ({rooms} rooms, {batches} open audit)": "{checklists} قائمة تحقق للغرف ({rooms} غرفة، {batches} جرد مفتوح)",
  "{checklists} room checklists ({rooms} rooms, {batches} open audits)": "{checklists} قائمة تحقق للغرف ({rooms} غرفة، {batches} عمليات جرد مفتوحة)",
  "{code} is a room, not an asset. Open it from Scan.": "{code} غرفة وليس أصلاً. افتحها من شاشة المسح.",
  "{item} marked as Returned ({condition}) and restored to active housekeeping inventory.": "تم وضع علامة مُعاد على {item} ({condition}) وإعادته إلى مخزون التدبير المنزلي النشط.",
  "{item} marked as Returned ({condition}) and withdrawn from the loaner fleet.": "تم وضع علامة مُعاد على {item} ({condition}) وسحبه من أسطول الإعارة.",
  "{n} assets for quick view": "{n} أصل للعرض السريع",
  "{n} conflict": "{n} تعارض",
  "{n} conflicts": "{n} تعارضات",
  "{n} count sheets": "{n} ورقة عد",
  "{n} first-walk rooms": "{n} غرفة للجولة الأولى",
  "{n} Item": "{n} صنف",
  "{n} Items": "{n} أصناف",
  "{n} items could not be downloaded": "تعذر تنزيل {n} عنصر",
  "{n} loans": "{n} إعارة",
  "{n} locations": "{n} موقع",
  "{n} not accepted": "{n} غير مقبول",
  "{n} returned damaged": "{n} أُعيد تالفًا",
  "{n} synced": "{n} تمت مزامنته",
  "{pct}% in housekeeping store": "{pct}% في مخزن التدبير المنزلي",
  "{tag} is now graded {grade}.": "تم تقييم {tag} الآن بدرجة {grade}.",
  "{tag} returned in {condition} condition.": "تمت إعادة {tag} بحالة {condition}.",
  "· {n} need attention": "· {n} بحاجة إلى انتباه",
  "· {n} waiting to sync": "· {n} بانتظار المزامنة",
};
